import { useCallback, useState } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIAbstractRatingInput from 'UIComponents/input/abstract/UIAbstractRatingInput';
import { useReviewContext } from './ReviewContextProvider';
import { PillIcon, StarRating, StarRatingDisabled } from './AbstractRatingIcons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ReviewRatingInput({
  dataTestId,
  disabled,
  fieldKey,
  label,
  showTextRating = true,
  tooltip,
  type = 'star'
}) {
  const {
    getFieldValidation,
    onUpdateReview,
    review
  } = useReviewContext();
  const {
    required
  } = getFieldValidation('ratings', fieldKey);
  const rating = review.ratings[fieldKey];
  const [ratingText, setRatingText] = useState(rating ? unescapedText(`trellisEcosystem.reviews.ratingDescriptions.${rating}`) : '');
  const onHoveredValueChange = useCallback(({
    target: {
      value
    }
  }) => {
    if (!value && !rating) {
      setRatingText('');
    } else {
      setRatingText(unescapedText(`trellisEcosystem.reviews.ratingDescriptions.${value || rating}`));
    }
  }, [rating]);
  let IconComponent;
  switch (type) {
    case 'pill':
      IconComponent = PillIcon;
      break;
    default:
      if (disabled) {
        IconComponent = StarRatingDisabled;
      } else {
        IconComponent = StarRating;
      }
      break;
  }
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: label,
    required: required,
    tooltip: tooltip,
    tooltipPlacement: "right",
    children: /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      direction: "row",
      children: [/*#__PURE__*/_jsx(UIAbstractRatingInput, {
        className: "display-flex m-y-1",
        "data-test-id": dataTestId,
        disabled: disabled,
        defaultValue: rating || 0,
        IconComponent: IconComponent,
        onChange: ({
          target: {
            value
          }
        }) => {
          if (parseInt(value, 10) > 0) {
            setRatingText(unescapedText(`trellisEcosystem.reviews.ratingDescriptions.${value}`));
            onUpdateReview({
              ratings: {
                [fieldKey]: value
              }
            });
          }
        },
        onHoveredValueChange: onHoveredValueChange,
        showPercentage: true
        // @ts-expect-error UIAbstractRatingInput expects number, but underlying UIIconToggle expects string
        ,
        size: 'sm',
        value: rating
      }), /*#__PURE__*/_jsx("span", {
        className: "rating-label m-left-3",
        "data-test-id": `${dataTestId}-label`,
        children: showTextRating && ratingText
      })]
    })
  });
}